<template>
  <lb-dialog
    v-model="internalValue"
    heading="Custom GL Filter"
    width="800"
  >
    <template v-slot:body>
      <div>
        <div class="mb-4">
          <lb-string
            :value="searchcustom"
            @input="updateSearch"
            hidedetails
            placeholder="Search GL Code or Description..."
          />
        </div>
        <div class="mt-2 ml-3 d-flex" v-if="hasSelections">
          {{ customfilter.length }} <span>Selected GL(s)</span>
          <v-spacer></v-spacer>
          <div class="mr-8">
            <v-btn class="secondaryBtn" @click="clearSelections"><span>Clear Selections</span></v-btn>
          </div>
        </div>
        <div v-if="!hasSearch">
          <div
            v-for="(item, index) in commentarydata"
            :key="item._id || index"
            class="tree-item"
            :style="{ 'padding-left': `${(item.glcode_detail?.path?.length || 1) * 20}px` }"
          >
            <div class="d-flex align-items-center pl-2">
              <v-checkbox
                class="mt-0"
                dense
                v-model="internalFilter"
                :value="item.glcode"
                multiple
                hide-details
              ></v-checkbox>
              <div :class="{ 'font-weight-semibold': item.glcode_detail?.path?.length === 1 }">
                <div class="mt-2">
                  <span>{{ item.__code }}</span> -
                  <span class="noTransform">{{ item.glcode_detail?.name }}</span>
                </div>
              </div>
            </div>
            <v-divider></v-divider>
          </div>
        </div>
        <div v-else>
          <div
            v-for="(item, index) in filteredMatches"
            :key="item._id || index"
            class="tree-item"
            :style="{ 'padding-left': `${(item.glcode_detail?.path?.length || 1) * 20}px` }"
          >
            <div class="d-flex align-items-center pl-2">
              <v-checkbox
                class="mt-0"
                dense
                v-model="internalFilter"
                :value="item.glcode"
                multiple
                hide-details
              ></v-checkbox>
              <div :class="{ 'font-weight-semibold': item.glcode_detail?.path?.length === 1 }">
                <div class="mt-2">
                  <span>{{ item.__code }}</span> -
                  <span class="noTransform">{{ item.glcode_detail?.name }}</span>
                </div>
              </div>
            </div>
            <v-divider></v-divider>
          </div>
        </div>
      </div>
    </template>
    <template v-slot:actions>
      <v-spacer></v-spacer>
      <v-btn class="ml-2" color="primary" @click="$emit('save')">
        <span>Save filter</span>
      </v-btn>
    </template>
  </lb-dialog>
</template>

<script>
export default {
  name: 'CustomFiltersDialog',
  props: {
    value: { type: Boolean, default: false },
    searchcustom: { type: String, default: '' },
    customfilter: { type: Array, default: () => [] },
    commentarydata: { type: Array, default: () => [] },
  },

  computed: {
    internalValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
    hasSelections() {
      return this.customfilter && this.customfilter.length > 0;
    },
    internalFilter: {
      get() {
        return this.customfilter;
      },
      set(value) {
        this.$emit('update:customfilter', value);
      },
    },
    hasSearch() {
      return this.searchcustom && this.searchcustom.trim().length > 0;
    },
    filteredMatches() {
      if (!this.hasSearch) return [];
      const query = this.searchcustom.replaceAll(' ', '').toLowerCase();
      return this.commentarydata.filter((item) => {
        const combined = `${item.glcode_detail?.code || ''}${item.glcode_detail?.name || ''}`
          .replaceAll(' ', '')
          .toLowerCase();
        return combined.includes(query);
      });
    },
  },
  methods: {
    updateSearch(value) {
      this.$emit('update:searchcustom', value);
    },
    clearSelections() {
      this.$emit('update:customfilter', []);
    },
  },
};
</script>
